import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import Website from "@/pages/Website";
import Social from "@/pages/Social";
import PaidAds from "@/pages/PaidAds";
import Leads from "@/pages/Leads";
import SettingsPage from "@/pages/SettingsPage";
import AppShell from "@/components/AppShell";

function FullScreenLoader() {
  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
    </div>
  );
}

function Protected({ children }) {
  const { user, org, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (org && !org.onboarded && location.pathname !== "/onboarding")
    return <Navigate to="/onboarding" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

const shell = (Page) => (
  <Protected><AppShell><Page /></AppShell></Protected>
);

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
      <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
      <Route path="/" element={shell(Home)} />
      <Route path="/website" element={shell(Website)} />
      <Route path="/social" element={shell(Social)} />
      <Route path="/paid-ads" element={shell(PaidAds)} />
      <Route path="/leads" element={shell(Leads)} />
      <Route path="/settings" element={shell(SettingsPage)} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
